// GestionTitle.jsx - Version simplifiée
import TitleGraphe from "./TitleGraphe";
import Layout from "../../Shared/Layout";
import GlobalSecurities from "./GlobalSecurities";
import TitlesForm from "./TitleForm";

const GestionTitle = () => {
  return (
    <Layout>
      <div className="content-body default-height">
        <div className="container-fluid">
          <TitlesForm />
          <TitleGraphe />
          <GlobalSecurities />
        </div>
      </div>
    </Layout>
  );
};

export default GestionTitle;